import script from "./RoundPlay.vue?vue&type=script&setup=true&lang=js"
export * from "./RoundPlay.vue?vue&type=script&setup=true&lang=js"

import "./RoundPlay.vue?vue&type=style&index=0&id=035062f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-035062f6"]])

export default __exports__